const MESES_LETRAS = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

const MESES_COMPLETOS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const PERIODOS = { ANO_ACTUAL: "ano_actual", ULTIMOS_12: "ultimos_12" };

/**
 * Las 12 claves "MM-YYYY" del período elegido, en orden cronológico (para la tira de calor,
 * izquierda = mes más viejo). "Año en curso": enero a diciembre del año calendario actual.
 * "Últimos 12 meses": el mes en curso y los 11 anteriores.
 * @param {string} periodo - uno de PERIODOS
 * @param {Date} [hoy]
 * @returns {string[]}
 */
export const getMesesDelPeriodo = (periodo, hoy = new Date()) => {
  if (periodo === PERIODOS.ANO_ACTUAL) {
    const ano = hoy.getFullYear();
    return Array.from({ length: 12 }, (_, i) => `${String(i + 1).padStart(2, "0")}-${ano}`);
  }
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date(hoy.getFullYear(), hoy.getMonth() - (11 - i), 1);
    return `${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  });
};

/**
 * Las 12 claves del MISMO período, un año antes (2026-09-24, 17ª sesión, pedido de Ignacio, punto
 * 0/3) — "año anterior" (AA). Truco: en vez de reimplementar la ventana, se llama a
 * `getMesesDelPeriodo` con `hoy` corrido exactamente un año atrás (mismo mes, día 1 — el día no
 * afecta el cálculo, solo mes/año). Para "Año en curso" da enero-diciembre del año anterior
 * (`hoy.getFullYear()-1` adentro de `getMesesDelPeriodo`); para "Últimos 12 meses" da la MISMA
 * ventana rodante corrida 12 meses atrás — si la actual va de octubre 2025 a septiembre 2026, con
 * `hoy` en septiembre 2025 la ventana calculada es octubre 2024 a septiembre 2025, exactamente lo
 * pedido. Un solo lugar (10.1) — ningún caso especial por tipo de período, la misma función de
 * siempre hace todo el trabajo.
 * @param {string} periodo - uno de PERIODOS
 * @param {Date} [hoy]
 * @returns {string[]}
 */
export const getMesesDelPeriodoAA = (periodo, hoy = new Date()) =>
  getMesesDelPeriodo(periodo, new Date(hoy.getFullYear() - 1, hoy.getMonth(), 1));

/** "01-2026" → "ENE" — encabezado de columna de la tira de calor (2026-09-23, sin año: el año ya
 * está en el selector de período, repetirlo 12 veces era redundante). */
export const etiquetaMesCorta = (mesClave) => MESES_LETRAS[parseInt(mesClave.split("-")[0], 10) - 1];

/**
 * Encabezado de columna, sensible al período (2026-09-24, 12ª sesión, punto 2 del pedido de
 * Ignacio). "Año en curso" — el año del selector ya identifica la fila entera, sigue sin repetirlo
 * (`etiquetaMesCorta` de siempre, "ENE"). "Últimos 12 meses" — las 12 columnas cruzan DOS años
 * calendario (ej. octubre 2025 a septiembre 2026), así que el año solo en el mes ya no alcanza:
 * suma el año de DOS DÍGITOS ("OCT 25", "ENE 26") para desambiguar sin ocupar el ancho de la celda
 * (34px) con 4 dígitos.
 * @param {string} mesClave - "MM-YYYY"
 * @param {string} periodo - uno de PERIODOS
 */
export const etiquetaMesCabezal = (mesClave, periodo) => {
  const letras = etiquetaMesCorta(mesClave);
  if (periodo !== PERIODOS.ULTIMOS_12) return letras;
  const anoCorto = mesClave.split("-")[1].slice(-2);
  return `${letras} ${anoCorto}`;
};

/** "01-2026" → "Enero 2026" — mes y año completos, primera línea del tooltip de la celda
 * (2026-09-24: reemplaza a `etiquetaMes`, la versión abreviada que usaba el tooltip viejo — el
 * tooltip ya no repite lo que dice el cuadrado, así que el mes/año se escriben enteros). */
export const etiquetaMesCompleto = (mesClave) => {
  const [mm, yyyy] = mesClave.split("-");
  return `${MESES_COMPLETOS[parseInt(mm, 10) - 1]} ${yyyy}`;
};
